export const PrimengIT = {
    dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    dayNamesMin: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
    monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Sett', 'Ott', 'Nov', 'Dic'],
    today: 'Oggi',
    accept: 'Sì',
    reject: 'No',
    emptyMessage: 'Nessun risultato trovato',
    emptyFilterMessage: 'Nessun risultato trovato',
    emptySearchMessage: 'Nessun risultato trovato',
    choose: 'Scegli',
    upload: 'Carica',
    cancel: 'Annulla',
    selectionMessage: '{0} elementi selezionati',
    emptySelectionMessage: 'Nessun elemento selezionato',
    noFileChosenMessage: 'Nessun file selezionato',
    dateFormat: 'dd/mm/yy',
};
